import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const CreatePlanItemSchema = Yup.object().shape({
  geographicalZone: yupRequiredString,
  productTypeId: yupRequiredString,
})
